/**
 * AgendaPagina.jsx — l'Agenda dello stile dell'utenza (interruttore dello
 * stile, Alex 14/10/2026).
 *
 * Con lo stile di prima e' Agenda, la griglia e le finestre di main; con lo
 * stile nuovo «Console» e' AgendaConsole, che ha la testata «‹ Oggi ›», il
 * pulsante «Agende», le sovrapposizioni affiancate, gli annullati disegnati
 * dietro, la settimana e il pannello a destra. Due componenti, due serie di
 * fogli (Agenda*.css sotto .stile-classico, Agenda*Console.css sotto
 * .stile-console) e non una condizione dentro uno solo: a interruttore spento
 * il disegno e' quello di prima per costruzione, e quando il vecchio stile si
 * toglie si cancellano i file senza ripulire un componente.
 * Lo stile lo decide il server e arriva con l'utente (navigazione/paginaIniziale).
 *
 * @varianti Agenda.jsx AgendaConsole.jsx
 */
import React from 'react';
import { useAuthStore } from '../store/useStore';
import { stileNuovo } from '../navigazione/paginaIniziale';
import Agenda from './Agenda';
import AgendaConsole from './AgendaConsole';

const AgendaPagina = () => {
    const utente = useAuthStore((st) => st.user);
    return stileNuovo(utente) ? <AgendaConsole /> : <Agenda />;
};

export default AgendaPagina;
